import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
import toggles from 'feature-toggles'
// Icons
import { HelpIcon } from 'images/icons'
// Components
import { ActivityMonitor } from 'components/wrapper/activity-monitor'
import Header from 'components/wrapper/header'
import SummaryBar from 'components/wrapper/summary-bar'
import OverlaySpinner from 'components/spinner/overlay-spinner'
import Sidebar from 'components/wrapper/sidebar'
import { TooltipHost } from 'components/tooltip/with-tip'
import { ModalHost } from 'components/modal/modal-host'
import { Help_s, Main_s } from 'components/wrapper/wrapper-styles'
// Services
import automationService from "data/automation"
import loadingService from 'data/loading'
import keyService, * as chord from "data/key"
import {local, setlocal, clearlocal} from 'data/lib/local-json'
// Styles
import { SummaryBar_s } from 'components/wrapper/wrapper-styles'

const Wrapper: FC<{path: string}> = (props) => {

  const [loading, setLoading] = useState<boolean>(false);
  const [summaryBarOpen, setSummaryBarOpen] = useState<boolean>(local("summaryBarOpen") || false);

  useEffect(() => {
    keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_ALT_H && k.down === true:
          showZendeskWidget()
          break
      }
    })
    loadingService.stream().subscribe(data => {
      setLoading(data.loading);
    })

    const noHotkeyZoom = (e) => {
      if((e.ctrlKey || e.metaKey) && _.includes(["_", "=", "+", "-", "Add", "Subtract"], e.key)) {
        e.preventDefault()
        return false
      }
    }

    const summaryBar = document.getElementById('summaryBar')
    summaryBar?.addEventListener("toggle", (event) => {
      if (summaryBar['open']) {
        setSummaryBarOpen(true)
        setlocal("summaryBarOpen", true)
        automationService.broadcast("SUMMARY_BAR_OPEN", true)
      } else {
        setSummaryBarOpen(false)
        setlocal('summaryBarOpen', false)
        automationService.broadcast("SUMMARY_BAR_OPEN", false)
      }
    });

    if(!_.get(summaryBar, 'open') && summaryBarOpen) {
      _.set(summaryBar, "open", true)
    }

    document.addEventListener("keydown", noHotkeyZoom)
    return () => {
      document.removeEventListener("keydown", noHotkeyZoom)
    }
  }, [])

  function showZendeskWidget():void {
    if(window.zE) {
      const profile = JSON.parse(localStorage.getItem('auth.profile')!);
      if (profile) {
        window.zE(() => window.zE.identify({
          name: profile.name,
          email: profile.email
        }));
      }
      window.zE(() => window.zE.activate({hideOnClose: true}));
    }
  }

  const profile = JSON.parse(localStorage.getItem('auth.profile')!);

  if(toggles.displayAppCues() && profile) {
    window.Appcues && window.Appcues.identify(profile.user_id, {isAdmin: profile.roletype.name === 'admin' || profile.roletype.name === 'support'});
  }

  return (
    <div>
      <Header />
      <SummaryBar_s id="summaryBar" summaryBarOpen={summaryBarOpen}>
        <summary>Property Summary</summary>
        <SummaryBar />
      </SummaryBar_s>
      <Sidebar summaryBarOpen={summaryBarOpen} />
      <Main_s summaryBarOpen={summaryBarOpen}>
        { props.children }
      </Main_s>
      <Help_s onClick={showZendeskWidget}>
        <Isvg src={HelpIcon} />
      </Help_s>
      <ActivityMonitor logoutAfter={60} warnBefore={5}/>
      { loading && <OverlaySpinner /> }
      <TooltipHost />
      <ModalHost />
    </div>
  )
}

export default Wrapper
